import { getGridStringOperators } from '@mui/x-data-grid-premium';

export const IS_EMPTY = 'isEmpty';
export const IS_NOT_EMPTY = 'isNotEmpty';

const EMPTY_ASSIGNEE = '-- --';

const isEmptyAssignee = value => !value || value === EMPTY_ASSIGNEE;

export const assigneeFilterOperators = getGridStringOperators().map(op => {
  if (op.value === IS_EMPTY) return { ...op, getApplyFilterFn: () => value => isEmptyAssignee(value) };
  if (op.value === IS_NOT_EMPTY) return { ...op, getApplyFilterFn: () => value => !isEmptyAssignee(value) };
  return op;
});
